
define('text!ui/template/collection.html',[],function () { return '<!--\n/**\n * Copyright © Magento, Inc. All rights reserved.\n * See COPYING.txt for license details.\n */\n-->\n<each args="data: elems, as: \'element\'">\n    <render if="hasTemplate()"></render>\n</each>\n';});

